// import React from "react";

// const fleets = [
//   {
//     image: "/images/fleets/aura.jpg",
//     name: "Hyundai Aura",
//     desc: "Comfortable compact sedan perfect for city rides and airport transfers.",
//   },
//   {
//     image: "/images/fleets/dzire.jpg",
//     name: "Maruti Dzire",
//     desc: "Reliable and fuel-efficient sedan for daily travel.",
//   },
//   {
//     image: "/images/fleets/ertiga.jpg",
//     name: "Maruti Ertiga",
//     desc: "Spacious 6–7 seater ideal for family trips.",
//   },
//   {
//     image: "/images/fleets/innova.jpg",
//     name: "Toyota Innova Crysta",
//     desc: "Premium SUV known for comfort on long journeys.",
//   },
//   {
//     image: "/images/fleets/kia.jpg",
//     name: "Kia Carens / Kia SUV",
//     desc: "Modern and stylish MPV with great comfort features.",
//   },
//   {
//     image: "/images/fleets/tempo-traveller.jpg",
//     name: "Tempo Traveller",
//     desc: "Best choice for group tours and outstation travel.",
//   },
//   {
//     image: "/images/fleets/urbania.jpg",
//     name: "Force Urbania",
//     desc: "Luxury van for premium group travel experience.",
//   },
//   {
//     image: "/images/fleets/crysta.jpg",
//     name: "Innova Crysta",
//     desc: "High-comfort premium SUV for long-distance travel.",
//   },
//   {
//     image: "/images/fleets/bus.jpg",
//     name: "Mini Bus",
//     desc: "Perfect for medium-sized group travel.",
//   },
// ];

// const OurFleets = () => {
//   return (
// <>



//  <div className="breadcrumb-bar">
//         <div className="container">
//           <div className="row align-items-center text-center">
//             <div className="col-md-12 col-12">
//               <h2 className="breadcrumb-title text-white">Our Fleets</h2>
//             </div>
//           </div>
//         </div>
//       </div>


//     <section className="fleet-section p-0 py-4">
//       <div className="container">

//         {/* Heading */}
//         <div className="fleet-header">
         
         
//         </div>

//         {/* Grid */}
//         <div className="fleet-grid">
//           {fleets.map((item, index) => (
//             <div className="fleet-card" key={index}>

//               {/* IMAGE */}
//               <div className="fleet-image">
//                 <img src={item.image} alt={item.name} />
//               </div>

//               <h3>{item.name}</h3>
//               <p>{item.desc}</p>

//               <a href="/booking" className="fleet-btn">
//                 Book Now
//               </a>

//             </div>
//           ))}
//         </div>

//       </div>
//     </section>
// </>
//   );
// };

// export default OurFleets;











import React from "react";

const fleets = [
  {
    image: "/images/fleets/aura.jpg",
    name: "Hyundai Aura",
    desc: "Comfortable compact sedan perfect for city rides and airport transfers.",
    seater: "4+1 Seater",
    luggage: "2 Bags",
    ac: "AC",
  },
  {
    image: "/images/fleets/Dzire.jpg",
    name: "Maruti Dzire",
    desc: "Reliable and fuel-efficient sedan for daily travel.",
    seater: "4+1 Seater",
    luggage: "2 Bags",
    ac: "AC",
  },
  {
    image: "/images/fleets/Ertiga.jpg",
    name: "Maruti Ertiga",
    desc: "Spacious 6–7 seater ideal for family trips.",
    seater: "6+1 Seater",
    luggage: "4 Bags",
    ac: "AC",
  },
  {
    image: "/images/fleets/innova.jpg",
    name: "Toyota Innova Crysta",
    desc: "Premium SUV known for comfort on long journeys.",
    seater: "7+1 Seater",
    luggage: "5 Bags",
    ac: "AC",
  },
  {
    image: "/images/fleets/kia.jpg",
    name: "Kia Carens",
    desc: "Modern and stylish MPV with great comfort features.",
    seater: "6+1 Seater",
    luggage: "4 Bags",
    ac: "AC",
  },

   {
    image: "/images/fleets/crysta.jpg",
    name: "Innova Crysta",
    desc: "High-comfort premium SUV for long-distance travel.",
    seater: "7+1 Seater",
    luggage: "5 Bags",
    ac: "AC",
  },

  {
    image: "/images/fleets/tempo-traveller.jpg",
    name: "Tempo Traveller",
    desc: "Best choice for group tours and outstation travel.",
    seater: "17 Seater",
    luggage: "10 Bags",
    ac: "AC",
  },
  
 
  {
    image: "/images/fleets/urbania.jpg",
    name: "Force Urbania",
    desc: "Luxury van for premium group travel experience.",
    seater: "17 Seater",
    luggage: "12 Bags",
    ac: "AC",
  },

  {
    image: "/images/fleets/bus.jpg",
    name: "Mini Bus",
    desc: "Perfect for medium-sized group travel.",
    seater: "32 Seater",
    luggage: "15 Bags",
    ac: "AC",
  },
];

const OurFleets = () => {
  return (
    <>
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white">
                Our Fleets
              </h2>
            </div>
          </div>
        </div>
      </div>

      <section className="fleet-section py-4 ">
        <div className="container">
          <div className="fleet-grid ">
            {fleets.map((item, index) => (
              <div className="fleet-card borderrr" key={index}>
                <div className="fleet-image">
                  <img src={item.image} alt={item.name} />
                </div>

                <div className="fleet-content borderrr">
                  <h3>{item.name}</h3>
                  <p>{item.desc}</p>

                  <div className="fleet-specs">
                    <span>👥 {item.seater}</span>
                    <span>🧳 {item.luggage}</span>
                    <span>❄️ {item.ac}</span>
                  </div>

                  <a href="/booking" className="fleet-btn">
                    Book Now
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OurFleets;

